import { createContext } from 'react';
import type { UsersApiClient } from './types';

export const UsersApiContext = createContext<UsersApiClient | null>(null);
